 $(window).on('load',function(){

  function closePopup() {
    $('.popupBox').removeClass('fadeInUp');
    $('.popupBox').addClass('slideOutUp');
    $('.popupOverlay').fadeOut('slow');
    $('.cls_popup').remove();
    $('body').removeClass('popupOpned');
    
    if($('#manvideo').length) {
      $('#manvideo')[0].contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');   
    }
  }
  function openPopup(a) {
    $('.popupBox').addClass('fadeInUp');
    $('.popupBox').removeClass('slideOutUp');
    $('.popupOverlay.'+a).fadeIn('slow');
    $('body').addClass('popupOpned');
    $('.popupBox').append('<a class="cls_popup" ></a>');
  }

  window.onclick = function(e) {
    if ($(e.target).hasClass('popupOverlay')) {
      closePopup();
    }  
  }
  $('body').on('click','.cls_popup',function(e){
    e.preventDefault();
    closePopup();
  });
  $(document).keyup(function(e) {
    if (e.keyCode == 27) { 
      closePopup();
    }
  });

//   $('.topbar a').on('click', function(e){
//     e.preventDefault();
//     openPopup('topbarShipping');
//   });


  $('.pdpShippingMsg a').on('click', function(e){
    e.preventDefault();
    openPopup('addnlContent');
  });

  function refreshHeigh() {
    var bh = $('.cartButtonOuter').height()+70;
    var vh = window.innerHeight;
    var newh = vh-bh;
    var qih = $('.quick-items').height();
    $('.cartDrawer').removeClass('nofix');
    $('.quick-items').removeAttr('style');
    if(newh > 115) { // 115 is one line-item height in cart 
      if(qih > newh) {
        $('.quick-items').css('max-height',newh+'px').css('overflow-y','scroll');
      }
    }
    else {
      $('.cartDrawer').addClass('nofix');
    }
  }

  refreshHeigh();

  $(window).resize(function(){
    setTimeout(function() {
      refreshHeigh();
      $('.cartDrawer').css("height", window.innerHeight+'px');
    }, 50); 
  });
  $(document).on({
    mouseenter: function() {
      $(".mainSections").addClass('menuHover');
      $('.site-nav').addClass('menuBg');
    },
    mouseleave: function() {
      $(".mainSections").removeClass('menuHover');
      $('.site-nav').removeClass('menuBg');
    }
  }, ".hasDropDown");
  
  $('.dropdownmenu').each(function(){
    var lp = $(this).offset().left;
    if(lp < 0) {
      $(this).parent().addClass('rmPosRel');
    }
  });
  $('.hasDropDown').hover(function(){
    var d = $(this).find('.dropdownmenu');
    if(d.length) {
      var lp = d.offset().left;
      if(lp < 0) {
        $(this).addClass('pushtoLeft');
      } else {
        $(this).removeClass('pushtoLeft');
      }
      var rp = ($(window).width() - (d.offset().left + d.outerWidth()));
      if(rp < 0) {
        $(this).addClass('pushtoRight');
      } else {
        $(this).removeClass('pushtoRight');
      }
    }
  });

  $('.mobileNav').on('click',function(e){
    e.preventDefault();
    setTimeout(function(){
      $('body').addClass('menuOpen');
      $('.fullPage').addClass('witmenu');
    }, 100);
  });
  $('.filterToggle').on('click',function(e){
    e.preventDefault();
    setTimeout(function(){
      $('body').addClass('filterOpen');
      $('.fullPage').addClass('witmenu');
    }, 50);
  });
  $('.closeFilter').on('click',function(e){
    e.preventDefault();
    setTimeout(function(){
      $('body').removeClass('filterOpen');
      $('.fullPage').removeClass('witmenu');
    }, 50);
  });
  
  $('#mainNavMob').on('click','.toggleItem',function(e){
    if($(this).hasClass('opend')) {
      $('.toggleItem').removeClass('opend');
      $('.dropdownmenu').removeClass('toggleSubMenu');
    } else {
      $('.toggleItem').removeClass('opend');
      $('.dropdownmenu').removeClass('toggleSubMenu');
      $(this).addClass('opend');
      $(this).parent().next('ul').addClass('toggleSubMenu');
    }
  });
  $('#mainNavMob').on('click','.backTitle',function(e){
    $('.toggleItem').removeClass('opend');
    $('.dropdownmenu').addClass('hideToggleMenu');
    setTimeout(function(){
      $('.dropdownmenu').removeClass('toggleSubMenu').removeClass('hideToggleMenu');
    },500);
    $('.mobileMenu').removeClass('mobfoxheight');
  });
  
  $('#mainNavMob').on('click','.col_menu_only .menu_only_title',function(e){
    var h = $(this).closest('ul')[0].scrollHeight;
    $(this).closest('ul')[0].scrollTop = 0;
    $(this).closest('ul').css('overflow','hidden');
    $(this).next('ul').addClass('menu_step3'); //.css('min-height',h+'px');

  });

  $('#mainNavMob').on('click','.backTitle3',function(e){
    var btn = $(this);
    btn.closest('.toggleSubMenu').removeAttr('style');
    btn.closest('ul').addClass('hidemenu_step3');
    setTimeout(function(){
      btn.closest('ul').removeClass('menu_step3').removeClass('hidemenu_step3');
    },500);
  });

  $('body').on('click','.openThird',function(e){
    e.preventDefault();
    var btn = $(this);
    btn.closest('.hasThird').removeAttr('style');
    btn.closest('.hasThird').addClass('thirdNavOpen');
  });
  
  $('body').on('click','.hasThird h4',function(e){
    e.preventDefault();
    var btn = $(this);
    btn.closest('.hasThird').removeClass('thirdNavOpen');
  });
  
  $('body').on('click','.fullPage.witmenu, .closemenu, .closecart', function(e){
    if($(this).closest('.colSidebar').length) {
      return false;
    }
    e.preventDefault();
    $('body').removeClass('menuOpen');
    $('.fullPage').removeClass('witmenu');
    $('body').removeClass('filterOpen');
    $('body').removeClass('cartOpen');
  });
  
  $('.menu-overlay').on('click', function(e){
    e.preventDefault();
    $('body').removeClass('menuOpen');
    $('.fullPage').removeClass('witmenu');
    $('body').removeClass('filterOpen');
    $('body').removeClass('cartOpen');
  });
  
  
  
  $('.mobToggler').on('click',function(e){
    $(this).next('div').slideToggle();
    $(this).toggleClass('opned');
  });
  window.onload = function() {
    $('.full_banner').each(function(){
      var img = $(this).attr('data-banner');
      $(this).css('background-image','url('+img+')');
      $(this).find('img').attr('src',img);
    });
    if($(window).width() <= 991) {
      $('.afterLoad').each(function(){
        var img = $(this).attr('data-src');
        $(this).attr('src', img);
      });
    }
  };

  function addToCartSuccess() {
    $.get( "/cart?view=mini", function( data ) {
      $('#crt').html(data);
      $('#crt').removeClass('loading');
      
      setTimeout(function() {
        refreshHeigh();
        $('.cartDrawer').css("height", window.innerHeight+'px');
      }, 100); 
      //Currency.convertAll(shopCurrency, $('.currentCurreny > span').text());
      //jQuery('.currentCurreny > span').text(Currency.currentCurrency); 
      if (window.Shopify && Shopify.StorefrontExpressButtons) {
        Shopify.StorefrontExpressButtons.initialize();
      }
    });
  }

  $('.cartOuter').on('mouseenter, click',function(e){
    if($(this).find('.cartCount').text()!="0") {
      //addToCartSuccess();
      e.preventDefault();
      setTimeout(function(){
        $('body').addClass('cartOpen');
        $('.fullPage').addClass('witmenu');
      }, 50);
    }
  });
  

   
  $('.cartCount').on("DOMSubtreeModified",function(){
    addToCartSuccess();
  });
  
  

  $('body').on('click','.addtocart',function(e){
    e.preventDefault();
    var btn = $(this);
    var form = $(this).closest('form');
    btn.attr('disabled', 'disabled');
    btn.val('Adding...');
    form.find('.error').remove();

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: form.serialize(),
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        if(jqXHR) {
          var response = $.parseJSON(jqXHR.responseText);
          form.append('<p class="error">'+response.description+'</p>').find('.error').fadeIn().delay(4000).fadeOut();
        }
        btn.val('Add to my basket');
        btn.removeAttr('disabled');
      },
      success: function(product) {
        var _learnq = _learnq || [];
        var item = {
          Name: product.product_title,
          ProductID: product.product_id,
          ImageURL: product.image,
          URL: window.location.href,
          Brand: product.vendor,
          Price: product.price/100
        };
        _learnq.push(['track', 'Added to Cart', item]);
      }
    }).done(function( data ) {
      //addToCartSuccess();
      btn.val('Add to my basket');
      btn.removeAttr('disabled');
      $.getJSON('/cart.js', function(c){
        $('.cartCount').text(c.item_count);
      });
      $('body').addClass('cartOpen');
      $('.fullPage').addClass('witmenu');
    });

  });

  $("#crt").on('click', "a.remove_item", function(r){
    $('#crt').addClass('loading');
    r.preventDefault();
    var id = $(this).data("id");
    Shopify.changeItem(id,0, function(c){
      $('.itemCount, .cartCount').text(c.item_count);
      if(!c.item_count) {
        $('.itemCount').text('0');
        $('#crt').empty();
        $('#crt').append('<p class="emptyCart text-center">You have no items in your shopping cart.</p>');
        $('#crt').removeClass('has-item');
        $('#crt').removeClass('loading');
      }/* else {
        addToCartSuccess();
      }*/
    });
  });

  $('body').on('click', '.quick-cart-details .adjust',function(){

    var input = $(this).parent().find('input');
    var ip = parseInt(input.val());
    if($(this).hasClass('plus')) {
      ip = ip + 1;
    } else {
      ip = ip - 1;
    }
    if(ip==0) {
      return false;
    }
    input.val(ip);

    if (!$(this).hasClass('upsell_qty')) {
      $('#crt').addClass('loading');
      var id = parseInt(input.attr('data-id'));
      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: 'updates['+id+']='+ip,
        dataType: 'json',
        error: function(jqXHR, textStatus, errorThrown){
          var response = $.parseJSON(jqXHR.responseText);
          alert(response.description);
          $('#crt').removeClass('loading');
        },
        success: function(){
          //addToCartSuccess();
          $.getJSON('/cart.js', function(c){
            $('.itemCount, .cartCount').text(c.item_count);
          });
          $('#crt').removeClass('loading');
        }
      });
    }

  });

  $('.item-quantityg').keypress(function (e) {
    if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
      return false;
    }
  });

   $('.tablist ul li').click(function(e){
     if(!$(this).parents('.tablist').hasClass('tablist_404')){
       e.preventDefault();
       $('.tablist ul li').removeClass('activetab');
       $('.relatedProductC').hide();
       var currenTab = $(this).data('id');
       $(this).addClass('activetab');
       $('#'+currenTab).show();
       //var x = $(this).attr('data-slick');
       if($('.responsive').hasClass('slick-initialized')) {
         $('.responsive').slick('refresh');
       }
     }
   });


    $('.responsive').slick({
      dots: false,
      arrows: true,
      infinite: false,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  
  
  if($('#myVideo').length) {
    document.getElementById("myVideo").pause();
  }
  $(".fancybox_viral").click(function(event){
    event.preventDefault();
    document.getElementById("myVideo").play();
    $('.viralsweep_popup').addClass('open_viralpopup');
    $('body').addClass('open_viralpopupbody');
    $('html').addClass('open_viralpopuphtml');
  });
  $(".inner_viral_close").click(function(event){		
    event.preventDefault();
    document.getElementById("myVideo").pause();
    $('.viralsweep_popup').removeClass('open_viralpopup');
    $('body').removeClass('open_viralpopupbody');
    $('html').removeClass('open_viralpopuphtml');
  });
   
  var baseURL = "https://services.superga-usa.com/";
  /*$('.mainNewsletter').on('submit',function(e){
    e.preventDefault();    
    var x = true;
    $('.err-msg').remove();
    var form = $(this);
    var email = form.find("input[type='email']").val().trim();
    var em = form.find('input[type="email"]');
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if(em.val().trim() == '' || !regex.test(em.val())) {
      em.parent().append('<p class="err-msg">Please enter valid e-mail.</p>');
      x = false;
    } else {
      em.parent().find('.err-msg').remove();
    }

    if(x){
      $.ajax({
        type: "POST",
        url: baseURL + 'Responsys/AddNewsLetter',
        data: "email="+email+"&page=PopUp",
        dataType: "json",
        crossDomain: true,
        success: function (json) {
          //debugger;
          console.log(json);
          form.hide();
          form.parent().append("<span class='successMsg'>Thanks! Please confirm your subscription to our mailing list via the email we just sent you :)</span>");
          $('.nlMore input[type="email"]').val(email);
          //openPopup('nlMsg');
        },
        error: function (e) {
          //debugger;
          form.append('<p class="err-msg">Please try after some time!</p>');
        }
      });
    }
  });*/
  

  jQuery('#footerNewsletter').submit(function(event) {

    //this will prevent the default submit
    event.preventDefault(); 
    jQuery('.error').remove();
    var form = jQuery(this);
    var email = form.find("#footeremail").val();
    var source = 'Site Signups (Footer)';    
    var x = true;
    var flag = 1;
    jQuery('.err-msg').remove();
    var em = form.find('input[type="email"]');
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if(em.val().trim() == '' || !regex.test(em.val())) {
      em.parent().append('<p class="err-msg">Please enter valid e-mail...</p>');
      x = false;
      return false;
    } else {
      em.parent().find('.err-msg').remove();

      var source = 'Sign Up footer';
      var language = form.find('.language').val();
      var list_id = form.find('.listID').val();

      var settings = {
        "async": true,
        "crossDomain": true,
        "url": "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
        "method": "POST",
        "headers": {
          "content-type": "application/x-www-form-urlencoded",
          "cache-control": "no-cache"
        },
        "data": {
          "g": list_id,
          "email": email,
          "$source": source,
          "$language": language,
          "Accepts Marketing": false,
          "$fields": "$source, $language, Accepts Marketing"
        },
        success: function(){
          form.hide();
          form.parent().append('<p style="text-align:center;">Thanks for joining.</p>'); 
        },
        error: function(data, errorThrown) {
          jQuery('.error').remove();
          if(data.statusText == "BAD REQUEST") {
            form.parent().append('<p class="error">The email already subsribed!</p>');
          }

        }
      };
 
      jQuery.ajax(settings).done(function (response) {
        
      });

    }

  });
  
  
  $('#moreAboutYou').on('submit',function(e){
    e.preventDefault();    
    var x = true;
    $('.err-msg').remove();
    var form = $(this);
    var email = form.find("input[type='email']").val().trim();
    var em = form.find('input[type="email"]');
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if(em.val().trim() == '' || !regex.test(em.val())) {
      em.parent().append('<p class="err-msg">Please enter valid e-mail.</p>');
      x = false;
    } else {
      em.parent().find('.err-msg').remove();
    }
    
    if($('#agreementSMPass:checked').length) {
      var pc = form.find("input[name='pcode']");
      if(pc.val().trim() == '') {
        pc.parent().append('<p class="err-msg">Please enter Postal code.</p>');
        x = false;
      } else {
        pc.parent().find('.err-msg').remove();
      }
      
      var tp = form.find("input[name='telephone']");
      if(tp.val().trim() == '') {
        tp.parent().append('<p class="err-msg">Please enter Telephone.</p>');
        x = false;
      } else {
        tp.parent().find('.err-msg').remove();
      }
    }

    if(x){
      var mydata={
        email: email,
        page:"Footer"
      };
      $.ajax({
        type: "POST",
        url: baseURL + '*********',
        data: mydata,
        dataType: "json",
        crossDomain: true,
        success: function (json) {
          //debugger;
          console.log(json);
          form.hide();
          form.parent().append("<span>Thanks! Please confirm your subscription to our mailing list via the email we just sent you :)</span>");
           
        },
        error: function (e) {
          form.append('<p class="err-msg">Please try after some time!</p>');
        }
      });
    }
  });
  
  
});

$(document).mouseup(function(e){
  var container = $('.inner_viral');
  if (!container.is(e.target) && container.has(e.target).length === 0) {
    $(".viralsweep_popup").removeClass('open_viralpopup');
    $("body").removeClass('open_viralpopupbody');
    if($('#myVideo').length) {
      document.getElementById("myVideo").pause();
    }
  }
  
  $('body').on('click','.single-qty .qty-btn', function(){
    var input = $(this).parent().find('input');
    var ip = parseInt(input.val());
    console.log(ip, 'before');
    if($(this).hasClass('plus-symbol')) {
      ip = ip + 1;
    } else {
      ip = ip - 1;
    }
    if(ip==0) {
      return false;
    }
    console.log(ip, 'after');
    input.val(ip);
  }); 
  
  function addtocart(){
    $.get('/cart',function(data){
      var html = $(data).find('.cart-details').html();
      $('.cart-details').html(html);
    });
  }
  $('body').on('click','.btnadd',function(e){
    e.preventDefault();
    var btn = $(this);
    var form = $(this).closest('form');
    btn.val('Adding...');
    $.ajax({
      type : 'POST',
      url : '/cart/add.js',
      data :form.serialize(),   
      dataType: 'json',
      error : function(jqXHR, textStatus, errorThrown){        
        var response = $.parseJSON(jqXHR.responseText);
        form.append('<p class="error">'+response.description+'</p>').find('.error').fadeIn().delay(4000).fadeOut(); 
        $('#load-spinner').removeClass('loader');
      },
      success : function(){
        addtocart();
        $.getJSON('/cart.js', function(c){
          $('.cartCount').text(c.item_count);
        });
      }
    });
  });
  
 
});



$(document).ready(function(){
  function review_scroll(){
    if($('#reviews').outerHeight() > 0){
      $('html,body').animate({
        scrollTop: $('#reviews').offset().top
      }, 2000);
      return;
    }else{
      setTimeout(function(){
        review_scroll();
      },1000);
    }
  }
  var url = window.location.hash;
  if (url == '#reviews'){
    review_scroll();
  }
  
  
   $('body').on('click',".review_a .text-m",function(e){
    e.preventDefault();
    window.location = $(this).closest('.review_a').attr('href');
  });
  
   function setCookie(cname,cvalue,exdays) {
     const d = new Date();
     d.setTime(d.getTime() + (exdays*24*60*60*1000));
     let expires = "expires=" + d.toUTCString();
     document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
   }


  
   function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
  
   var c = 0; 
  function find_teaser(){
    if($('.kl-teaser-UD6ayU').length > 0 || $('.kl-teaser-XXfacM').length > 0 || $('.kl-teaser-WRwPw2').length > 0 || $('.kl-teaser-RHiFUr').length > 0){
      if(getCookie("teaser_closed") != 'yes'){
        if($('.kl-teaser-UD6ayU').length > 0){
          $('.kl-teaser-UD6ayU').parent().append('<div class="close klaviyo_teaser_close">x</div>');
        }
        if($('.kl-teaser-RHiFUr').length > 0){
          $('.kl-teaser-RHiFUr').parent().append('<div class="close klaviyo_teaser_close">x</div>');
        }
        if($('.kl-teaser-XXfacM').length > 0) {
          $('.kl-teaser-XXfacM').parent().append('<div class="close klaviyo_teaser_close">x</div>');
        }
        if ($('.kl-teaser-WRwPw2').length > 0){
          $('.kl-teaser-WRwPw2').parent().append('<div class="close klaviyo_teaser_close">x</div>');
        }
      } else{
        if($('.kl-teaser-UD6ayU').length > 0){
          $('.kl-teaser-UD6ayU').css("top","unset");
        }
        if($('.kl-teaser-RHiFUr').length > 0){
          $('.kl-teaser-RHiFUr').css("top","unset");
        }
        if($('.kl-teaser-XXfacM').length > 0) {
          $('.kl-teaser-XXfacM').css("top","unset");
        }
        if ($('.kl-teaser-WRwPw2').length > 0){
          $('.kl-teaser-WRwPw2').css("top","unset");
        }
      }
      return;
    } else{
      if (c < 20){
        setTimeout(function(){
          find_teaser();
        },1000);
        c++;
      }else{
        return;
      }
    }
  }
  
  find_teaser();

  $('body').on("click",".close.klaviyo_teaser_close",function(e){
    if($('.kl-teaser-UD6ayU').length > 0){
      $(this).hide().parent().find('.kl-teaser-UD6ayU').css("top","unset");
    }
    if($('.kl-teaser-RHiFUr').length > 0){
      $(this).hide().parent().find('.kl-teaser-RHiFUr').css("top","unset");
    }
    if($('.kl-teaser-XXfacM').length > 0) {
      $(this).hide().parent().find('.kl-teaser-XXfacM').css("top","unset");
    }
    if ($('.kl-teaser-WRwPw2').length > 0){
      $(this).hide().parent().find('.kl-teaser-WRwPw2').css("top","unset");
    }
    setCookie("teaser_closed","yes");
    $('.klaviyo_teaser_close').remove();
  });
  
  $('body').on("click",".klaviyo-close-form",function(){
    find_teaser();
  });
  
  $('body').on("click","button.kl-teaser-UD6ayU.needsclick,button.kl-teaser-WRwPw2.needsclick,button.kl-teaser-XXfacM.needsclick,button.kl-teaser-RHiFUr.needsclick",function(){
    $('.klaviyo_teaser_close').remove();
  });
  
  
});